// extracted by mini-css-extract-plugin
export default {"bottomNav":"RulesControl_bottomNav__MUdLn","navButton":"RulesControl_navButton__L39fi","active":"RulesControl_active__JuNg1"};